module.exports = __webpack_public_path__ + "static/barcelonaBarroc-5c8605e8b537f755ecf317453fdb27c2.png";